import { get } from "lodash";
import moment from "moment";
import PropTypes from "prop-types";
import { useContext } from "react";
import { AiOutlineLink } from "react-icons/ai";
import { BiCalendar, BiChart, BiSolidUser } from "react-icons/bi";
import { FiArrowUpRight } from "react-icons/fi";
import Button from "shared/components/Button";
import { StoreContext } from "shared/store";
import { CURRENCY_SYMBOL, DATE_FORMAT } from "utils/constants";
import { costToFrench } from "utils/helpers/values";
import Popover from "../Popover";

const Subscription = ({
  date,
  user,
  status,
  icon,
  product,
  category,
  tag,
  tracers,
  cost,
  currency,
  period,
  translation,
  onClick = () => {},
  onOpenGenerateLink = () => {},
  disabled,
  upsells,
  disabledGenerateLink,
}) => {
  const { user: loggedUser } = useContext(StoreContext);
  const [integer, decimal = "00"] = cost?.toString().split(".") || ["-"];
  const [AnsetInteger, AnsetDecimal = "00"] = costToFrench(cost / 11, 0)
    ?.toString()
    .split(".") || ["-"];

  return (
    <div className="subscription__card">
      <div className="subscription__card--head">
        <div className="infos">
          <div className="item popover-wrapper">
            <Popover text={translation.ISSUANCE_DATE} small />
            <BiCalendar />
            <span>{moment(date).format(DATE_FORMAT)}</span>
          </div>
          <div className="item">
            <BiSolidUser />
            <span>{user}</span>
          </div>
        </div>
        <div className="status">
          <BiChart />
          <span>{status}</span>
        </div>
      </div>
      <div className="subscription__card--body">
        <div className="product">
          <img src={icon} alt={product} />

          <div className="infos">
            <h4>{product}</h4>
            {upsells.map(({ insurancePlan: { name } }) => (
              <p key={name}>{name}</p>
            ))}
            <span>{category}</span>
            {/* <span className="tag">{tag}</span> */}
          </div>
        </div>
        <div className="pricing">
          <h4 className="price">
            {get(loggedUser, "organization.name") === "ANSET ASSURANCES" ? (
              <span>
                {`${AnsetInteger} ${CURRENCY_SYMBOL[currency]} `}
                <sup>{AnsetDecimal?.slice(0, 2)}</sup>
              </span>
            ) : (
              <span>
                {`${integer} ${CURRENCY_SYMBOL[currency]} `}
                <sup>{decimal?.slice(0, 2)}</sup>
              </span>
            )}
            <small>/{period}</small>
          </h4>
          <div className="price--info">
            <span>
              {`${(get(loggedUser, "organization.name") === "ANSET ASSURANCES"
                ? cost
                : +cost * 12
              ).toLocaleString("fr-FR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} ${CURRENCY_SYMBOL[currency]} ${translation.PER_YEAR} `}
            </span>
            {translation.ALL_COST}
          </div>
        </div>
      </div>
      <div className="subscription__card--action">
        <Button
          disabled={disabled.status || disabledGenerateLink}
          type={"primary"}
          size={24}
          onClick={onOpenGenerateLink}
        >
          {translation.GENERATE_LINK}
          <AiOutlineLink size={24} />
        </Button>

        <div className="item popover-wrapper">
          {disabled.status && <Popover text={disabled.text} small />}
          <Button
            type={"secondary"}
            size={24}
            onClick={onClick}
            disabled={disabled.status}
          >
            {translation.RESUME}
            <FiArrowUpRight size={24} />
          </Button>
        </div>
      </div>
    </div>
  );
};

Subscription.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.string,
};

Subscription.defaultProps = {
  cost: "00.00",
  currency: "EUR",
};

export default Subscription;
